/**
 * Locales supported by native JavaScript for Date and Number conversions.
 */

// JavaScript accepted locale keys
const LOCALES = ['en-US', 'es', 'fr-FR', 'pt-BR'];

// Django language key to JavaSript accepted locale key
const LANGUAGE_TO_LOCALE = {
    'en-us': 'en-US',
    es: 'es',
    'fr-fr': 'fr-FR',
    'pt-br': 'pt-BR'
};

export { LOCALES, LANGUAGE_TO_LOCALE };
